// import { CustomLightWeightChart } from '../../infrastructure/charts/customLightWeightChart'
// import { TradingDataAxios } from '../../infrastructure/api/tradingData/data.axios'

import OrdersController from './orders/orders.controller'
import TradeHistoryController from './tradeHistory/tradeHistory.controller'
import PositionsController from './positions/positions.controller'
import { InstrumentsApiAxios } from '@trading/infrastructure/src/api/instruments/data.axios'
import { MarketApiAxios } from '@trading/infrastructure/src/api/market/data.axios'
import { OrderApiAxios } from '@trading/infrastructure/src/api/orders/ordersRepo.axios'
import { PositionApiAxios } from '@trading/infrastructure/src/api/positions/positionsRepo.axios'
import { TradeHistoryApiAxios } from '@trading/infrastructure/src/api/tradeHistory/tradeHistory.axios'
import { AccountApiAxios } from '@trading/infrastructure/src/api/accounts/accountRepo.axios'
import { FeatureRepositoryAxios } from '@trading/infrastructure/src/api/features/feature.axios'
import InstrumentsController from './instruments/instruments.controller'
import MarketController from './market/market.controller'
import AccountsController from "./accounts/accounts.controller";
import AccountService from "../services/account.service";
import UserController from './user/user.controller'
import { UserRepositoryAxios } from '@trading/infrastructure/src/api/user/user.axios'
import AuthController from './auth/auth.controller'
import { AuthRepositoryAxios } from '@trading/infrastructure/src/api/auth/auth.axios'
import FeaturesController from "./features/features.controller";
import FeaturesService from "../services/features";
import SettingsController from './settings/settings.controller'
import SettingsService from '../services/settings.service'
import { SettingsRepositoryAxios } from '@trading/infrastructure/src/api/settings/settings.axios'

export function createApi() {
  return {
    orders: new OrdersController(new OrderApiAxios()),
    history: new TradeHistoryController(new TradeHistoryApiAxios()),
    positions: new PositionsController(new PositionApiAxios()),
    instruments: new InstrumentsController(new InstrumentsApiAxios()),
    market: new MarketController(new MarketApiAxios()),
    user: new UserController(new UserRepositoryAxios()),
    features: new FeaturesController(new FeatureRepositoryAxios()),
    auth: new AuthController(new AuthRepositoryAxios()),
    account: new AccountsController(new AccountApiAxios()),
    settings: new SettingsController(new SettingsRepositoryAxios()),
  }
}

export type Api = ReturnType<typeof createApi>

export function createServices(api: Api) {
  return {
    accounts: new AccountService(api.account),
    features: new FeaturesService(api.features),
    settings: new SettingsService(api.settings)
  }
}

export type Services = ReturnType<typeof createServices>
